import { default as flatpageqWK5Ljcoi8Meta } from "@/pages/flatpage.vue?macro=true";
import { default as indexCyDXVsBOJjMeta } from "/app/pages/[categories]/[product]/index.vue?macro=true";
import { default as indexQ9Q6BLcuJYMeta } from "/app/pages/basket/index.vue?macro=true";
import { default as bonusqWlhaVMAmFMeta } from "/app/pages/bonus.vue?macro=true";
import { default as indexkCvE3Ik3uGMeta } from "/app/pages/category/[category]/index.vue?macro=true";
import { default as _91slug_938UwMods1irMeta } from "/app/pages/delivery/[slug].vue?macro=true";
import { default as index5hjhhdoFvoMeta } from "/app/pages/delivery/index.vue?macro=true";
import { default as halvesgoAw7hoAaoMeta } from "/app/pages/halves.vue?macro=true";
import { default as indexN6pT4Un8hYMeta } from "/app/pages/index.vue?macro=true";
import { default as infoRUNMKy7QPmMeta } from "/app/pages/info.vue?macro=true";
import { default as loginhHM0vSTW5jMeta } from "/app/pages/login.vue?macro=true";
import { default as make_45wokE9bXs88BLAMeta } from "/app/pages/make-wok.vue?macro=true";
import { default as _91slug_93h6ecm9GkHAMeta } from "/app/pages/news/[slug].vue?macro=true";
import { default as indexoxV4GRc61hMeta } from "/app/pages/news/index.vue?macro=true";
import { default as payFTilofytcqMeta } from "/app/pages/pay.vue?macro=true";
import { default as payment0EDeMiyhRyMeta } from "/app/pages/payment.vue?macro=true";
import { default as index7VqBHXrsYZMeta } from "/app/pages/product/[product]/index.vue?macro=true";
import { default as bonus_45historydMv0ZNMScTMeta } from "/app/pages/profile/bonus-history.vue?macro=true";
import { default as cardsYN2MCAYSTuMeta } from "/app/pages/profile/cards.vue?macro=true";
import { default as indexaeouN7Kzh7Meta } from "/app/pages/profile/index.vue?macro=true";
import { default as notifications3lz9w79pbPMeta } from "/app/pages/profile/notifications.vue?macro=true";
import { default as _91id_93KMRVArJy0bMeta } from "/app/pages/profile/orders/[id].vue?macro=true";
import { default as indexuge52uLKPwMeta } from "/app/pages/profile/orders/index.vue?macro=true";
import { default as password_45changekSMiBJcm5ZMeta } from "/app/pages/profile/password-change.vue?macro=true";
import { default as promocodeswaMaArjlzPMeta } from "/app/pages/profile/promocodes.vue?macro=true";
import { default as settingssfrdss5mooMeta } from "/app/pages/profile/settings.vue?macro=true";
import { default as redirectvHLxODTt5rMeta } from "/app/pages/redirect.vue?macro=true";
import { default as _91slug_93UhgzLIZx0YMeta } from "/app/pages/sales/[slug].vue?macro=true";
import { default as _91slug_93y6we712PkdMeta } from "/app/pages/sales/archive/[slug].vue?macro=true";
import { default as indexnEBLM1qalAMeta } from "/app/pages/sales/archive/index.vue?macro=true";
import { default as indexgi1M0XIQhpMeta } from "/app/pages/sales/index.vue?macro=true";
import { default as sitemapbFBPe0edUzMeta } from "/app/pages/sitemap.vue?macro=true";
import { default as slot_45machineyvOrFHJy3JMeta } from "/app/pages/slot-machine.vue?macro=true";
import { default as component_45stubnO9MU04yTUMeta } from "/app/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubnO9MU04yTU } from "/app/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "about",
    path: "/about/",
    meta: {"layout":"default"},
    component: () => import("@/pages/flatpage.vue").then(m => m.default || m)
  },
  {
    name: "terms_of_use",
    path: "/terms_of_use/",
    meta: {"layout":"default"},
    component: () => import("@/pages/flatpage.vue").then(m => m.default || m)
  },
  {
    name: "confidential",
    path: "/confidential/",
    meta: {"layout":"default"},
    component: () => import("@/pages/flatpage.vue").then(m => m.default || m)
  },
  {
    name: "important/",
    path: "/important/",
    meta: {"layout":"default"},
    component: () => import("@/pages/flatpage.vue").then(m => m.default || m)
  },
  {
    name: "rules/",
    path: "/rules/",
    meta: {"layout":"default"},
    component: () => import("@/pages/flatpage.vue").then(m => m.default || m)
  },
  {
    name: "categories-product",
    path: "/:categories()/:product()",
    component: () => import("/app/pages/[categories]/[product]/index.vue").then(m => m.default || m)
  },
  {
    name: "basket",
    path: "/basket",
    component: () => import("/app/pages/basket/index.vue").then(m => m.default || m)
  },
  {
    name: "bonus",
    path: "/bonus",
    component: () => import("/app/pages/bonus.vue").then(m => m.default || m)
  },
  {
    name: "category-category",
    path: "/category/:category()",
    component: () => import("/app/pages/category/[category]/index.vue").then(m => m.default || m)
  },
  {
    name: "delivery-slug",
    path: "/delivery/:slug()",
    component: () => import("/app/pages/delivery/[slug].vue").then(m => m.default || m)
  },
  {
    name: "delivery",
    path: "/delivery",
    component: () => import("/app/pages/delivery/index.vue").then(m => m.default || m)
  },
  {
    name: "halves",
    path: "/halves",
    component: () => import("/app/pages/halves.vue").then(m => m.default || m)
  },
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "info",
    path: "/info",
    component: () => import("/app/pages/info.vue").then(m => m.default || m)
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/app/pages/login.vue").then(m => m.default || m)
  },
  {
    name: "make-wok",
    path: "/make-wok",
    component: () => import("/app/pages/make-wok.vue").then(m => m.default || m)
  },
  {
    name: "news-slug",
    path: "/news/:slug()",
    component: () => import("/app/pages/news/[slug].vue").then(m => m.default || m)
  },
  {
    name: "news",
    path: "/news",
    component: () => import("/app/pages/news/index.vue").then(m => m.default || m)
  },
  {
    name: "pay",
    path: "/pay",
    meta: payFTilofytcqMeta || {},
    component: () => import("/app/pages/pay.vue").then(m => m.default || m)
  },
  {
    name: "payment",
    path: "/payment",
    component: () => import("/app/pages/payment.vue").then(m => m.default || m)
  },
  {
    name: "product-product",
    path: "/product/:product()",
    component: () => import("/app/pages/product/[product]/index.vue").then(m => m.default || m)
  },
  {
    name: "profile-bonus-history",
    path: "/profile/bonus-history",
    component: () => import("/app/pages/profile/bonus-history.vue").then(m => m.default || m)
  },
  {
    name: "profile-cards",
    path: "/profile/cards",
    component: () => import("/app/pages/profile/cards.vue").then(m => m.default || m)
  },
  {
    name: "profile",
    path: "/profile",
    component: () => import("/app/pages/profile/index.vue").then(m => m.default || m)
  },
  {
    name: "profile-notifications",
    path: "/profile/notifications",
    component: () => import("/app/pages/profile/notifications.vue").then(m => m.default || m)
  },
  {
    name: "profile-orders-id",
    path: "/profile/orders/:id()",
    meta: _91id_93KMRVArJy0bMeta || {},
    component: () => import("/app/pages/profile/orders/[id].vue").then(m => m.default || m)
  },
  {
    name: "profile-orders",
    path: "/profile/orders",
    component: () => import("/app/pages/profile/orders/index.vue").then(m => m.default || m)
  },
  {
    name: "profile-password-change",
    path: "/profile/password-change",
    component: () => import("/app/pages/profile/password-change.vue").then(m => m.default || m)
  },
  {
    name: "profile-promocodes",
    path: "/profile/promocodes",
    component: () => import("/app/pages/profile/promocodes.vue").then(m => m.default || m)
  },
  {
    name: "profile-settings",
    path: "/profile/settings",
    component: () => import("/app/pages/profile/settings.vue").then(m => m.default || m)
  },
  {
    name: "redirect",
    path: "/redirect",
    component: () => import("/app/pages/redirect.vue").then(m => m.default || m)
  },
  {
    name: "sales-slug",
    path: "/sales/:slug()",
    component: () => import("/app/pages/sales/[slug].vue").then(m => m.default || m)
  },
  {
    name: "sales-archive-slug",
    path: "/sales/archive/:slug()",
    component: () => import("/app/pages/sales/archive/[slug].vue").then(m => m.default || m)
  },
  {
    name: "sales-archive",
    path: "/sales/archive",
    component: () => import("/app/pages/sales/archive/index.vue").then(m => m.default || m)
  },
  {
    name: "sales",
    path: "/sales",
    component: () => import("/app/pages/sales/index.vue").then(m => m.default || m)
  },
  {
    name: "sitemap",
    path: "/sitemap",
    component: () => import("/app/pages/sitemap.vue").then(m => m.default || m)
  },
  {
    name: "slot-machine",
    path: "/slot-machine",
    component: () => import("/app/pages/slot-machine.vue").then(m => m.default || m)
  },
  {
    name: "filter-category-category",
    path: "/category/filter/:category()",
    component: () => import("/app/pages/category/[category]/index.vue").then(m => m.default || m)
  },
  {
    name: component_45stubnO9MU04yTUMeta?.name,
    path: "/category",
    component: component_45stubnO9MU04yTU
  },
  {
    name: component_45stubnO9MU04yTUMeta?.name,
    path: "/product",
    component: component_45stubnO9MU04yTU
  }
]